import React, {useContext, useEffect, useState} from "react";
import {TranslateContext} from "../../../../context/TranslateContext";
import {deleteDocumentoKpiApi, getDocumentiKpiApi, getDocumentoKpiByIdApi} from "../../services/DocumentiServices";
import TabellaDocumentiKpiView from "./TabellaDocumentiKpiView";

export default function TabellaDocumentiKpiController({
                                                          idKpi,
                                                          idTipoImportDati,
                                                          countUpdate,
                                                          onDeleteDocumento = () => {
                                                          }
                                                      }) {

    const [loadingData, setLoadingData] = useState(true);
    const [documenti, setDocumenti] = useState([]);
    const [fileSel, setFileSel] = useState();
    const [docSel, setDocSel] = useState();
    const [docDel, setDocDel] = useState();
    const [showConfirm, setShowConfirm] = useState(false);
    const [show, setShow] = useState(false);
    const [modalMsg, setModalMsg] = useState('');

    const {translate} = useContext(TranslateContext);

    async function getDocumenti() {
        /*
         * Se ho selezionato un elemento dall'alberatura, filtro per lui.
         * Se il tipo è D (cartella), restituisco tutti i file della cartella.
         * Se il tipo è F (file), restituisco solo il file selezionato.
         */
        let filtro = `?id_tipo_imp_dati=${idTipoImportDati}`;
        if (fileSel) {
            filtro = '&idFile=' + fileSel.id;
        }

        const response = await getDocumentiKpiApi(idKpi, filtro);
        setDocumenti(response.data.data);
        setLoadingData(false);
    }

    useEffect(() => {
        getDocumenti();
    }, [idKpi, docDel, fileSel]);

    useEffect(() => {
        if (countUpdate && countUpdate > 0) {
            getDocumenti();
        }
    }, [countUpdate]);

    const downloadDocumento = async (doc, download) => {
        const response = await getDocumentoKpiByIdApi(idKpi, doc.id_documento_kpi);
        if (response.data.result === -1) {
            setModalMsg(response.data.description)
            setShow(true)
        } else {
            let resp = response.data.data;
            if (resp) {
                if (download === true) {
                    var a = document.createElement("a");
                    a.href = "data:" + resp.content_type + ";base64," + resp.contenuto;
                    a.download = resp.nome_file_originale;
                    a.click();
                } else {
                    var byteCharacters = atob(resp.contenuto);
                    var byteNumbers = new Array(byteCharacters.length);
                    for (var i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    var byteArray = new Uint8Array(byteNumbers);
                    var file = new Blob([byteArray], {type: resp.content_type + ';base64'});
                    var fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                }
            }
        }
    }

    const elimina = async () => {
        setShowConfirm(false);
        const response = await deleteDocumentoKpiApi(idKpi, docSel.id_documento_kpi);
        if (response.data.result === -1) {
            setModalMsg(response.data.description)
            setShow(true)
        } else {
            setDocDel(docSel.id_documento_kpi);
            onDeleteDocumento();
        }
    }

    return (
        !loadingData &&
        <TabellaDocumentiKpiView
            show={show}
            translate={translate}
            loadingData={loadingData}
            setShow={setShow}
            setShowConfirm={setShowConfirm}
            modalMsg={modalMsg}
            showConfirm={showConfirm}
            elimina={elimina}
            docSel={docSel}
            documenti={documenti}
            downloadDocumento={downloadDocumento}
            setDocSel={setDocSel}
        />
    );
}
